<template>
  <v-sheet :rounded="isSmallerDisplay() ? '' : 'lg'" v-if="$store.state.isUserLoggedIn">
    <div v-if="loading">
      <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
    </div>
    <div v-if="!loading && message">
      <v-card height="100%" class="text-left" elevation="0">
        <v-card-title>
          <v-avatar size="30">
            <img :src="academyImage" />
          </v-avatar>
          <span class="text-subtitle-1 ml-2">{{ message.title }}</span>
        </v-card-title>
        <v-card-text class="pl-3 text-body-2 ml-3" style="padding-left:20px">
          <div class="format-text">{{ message.contents }}</div>
        </v-card-text>
      </v-card>
      <v-card class="mt-2" v-if="visitorName">
        <v-card-text>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{ visitorName }}</v-list-item-title>
                <v-list-item-subtitle>{{ $t('message.name') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ visitorEmail }}
                  <v-btn small icon @click="copyToClipboard(visitorEmail)"><v-icon size="20">mdi-content-copy</v-icon></v-btn>
                </v-list-item-title>
                <v-list-item-subtitle>{{ $t('message.email') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="visitorPhone">
              <v-list-item-content>
                <v-list-item-title>
                  {{ visitorPhone }}
                  <v-btn small icon @click="copyToClipboard(visitorPhone)"><v-icon size="20">mdi-content-copy</v-icon></v-btn>
                  <v-btn small icon v-if="visitorWhatsAppLink" @click="openWhatsApp(visitorWhatsAppLink)">
                    <img width="20" :src="assets('icons/whatsapp.png')" />
                  </v-btn>
                </v-list-item-title>
                <v-list-item-subtitle>{{ $t('message.phone') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-for="field in visitorExtraFields" :key="field.fieldName">
              <v-list-item-content>
                <v-list-item-title>{{ field.value }}</v-list-item-title>
                <v-list-item-subtitle>{{ field.fieldName }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-card-text outlined v-if="visitorMessage">
            <div class="format-text">{{ visitorMessage }}</div>
          </v-card-text>
        </v-card-text>
      </v-card>
    </div>
  </v-sheet>
</template>
<script>
import AcademyService from "@/services/AcademyService";
import NotificationService from "@/services/NotificationService";

export default {
  data() {
    return {
      messageId: this.$route.params.messageId,
      visitorId: this.$route.query.visitor,
      message: null,
      academyName: null,
      loading: true,
      academyImage: this.assets('default-empty-academy.png'),
      visitorName: null,
      visitorEmail: null,
      visitorPhone: null,
      visitorMessage: null,
      visitorWhatsAppLink: null,
      visitorExtraFields: [],
    };
  },
  components: {
  },
  created() {
    NotificationService.notification(this.messageId)
      .then((result) => {
        if (result && result._id) {
          this.message = result;
          if (this.message._id) NotificationService.read(this.messageId);
          AcademyService.academy(this.message.objectId)
            .then((data) => {
              if (data) {
                if (data.academy.image)
                  this.academyImage = this.userImg(data.academy.image);
                this.academyName = data.academy.name;
              }
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
          if (this.visitorId) {
            AcademyService.getVisitor(this.message.objectId, this.visitorId)
              .then((data) => {
                if (data && data.visitor) {
                  const v = data.visitor;
                  this.visitorName = v.name;
                  this.visitorEmail = v.email;
                  this.visitorPhone = v.phone;
                  this.visitorMessage = v.message;
                  this.visitorWhatsAppLink = v.whatsAppLink || null;
                  this.visitorExtraFields = v.extraFieldValues || [];
                }
              });
          }
        }
      })
      .catch(() => {
        this.loading = false;
        this.showAlert("error", this.$t("message.oops_not_working"));
      });
  },
  methods: {
    agree() { },
    openWhatsApp(url) {
      if (!url) return;
      window.open(url);
    },
  },
  mounted() { },
  computed: {},
  watch: {},
};
</script>

<style scoped></style>
